"use strict";
// Copyright 2015 Grafana Labs
// Copyright 2021 YANDEX LLC
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateTimeParse = void 0;
var dayjs_1 = __importDefault(require("../dayjs"));
var dateTime_1 = require("../dateTime");
var datemath_1 = require("../datemath");
var parseInput = function (input, options) {
    var _a;
    if (typeof input === 'string' && input.indexOf('now') !== -1) {
        var allowRelative = (_a = options === null || options === void 0 ? void 0 : options.allowRelative) !== null && _a !== void 0 ? _a : true;
        if (!(0, datemath_1.isValid)(input) || !allowRelative) {
            return undefined;
        }
        return (0, datemath_1.parse)(input, options === null || options === void 0 ? void 0 : options.roundUp, options === null || options === void 0 ? void 0 : options.timeZone);
    }
    var _b = options || {}, format = _b.format, lang = _b.lang;
    var date = (0, dateTime_1.dateTime)({ input: input, format: format, lang: lang, timeZone: options === null || options === void 0 ? void 0 : options.timeZone });
    return date.isValid() ? date : undefined;
};
/**
 * Parses a number, text or Date to a DateTime value. If a timeZone is supplied the incoming value
 * is parsed with that timeZone as a base.
 *
 * It can also parse the relative date and time format, e.g. now-6h will be parsed as Date.now() - 6 hours and
 * returned as a valid DateTime value.
 *
 * If no options are supplied, then default values are used. For more details please see DateTimeOptionsWhenParsing.
 *
 * @param input - should be a parsable date and time input.
 * @param options
 */
var dateTimeParse = function (input, options) {
    if (!input) {
        return undefined;
    }
    dayjs_1.default.tz.setDefault(options === null || options === void 0 ? void 0 : options.timeZone);
    var date = parseInput(input, options);
    dayjs_1.default.tz.setDefault();
    return date;
};
exports.dateTimeParse = dateTimeParse;
